<template>
  <div id="app">
    <!-- 回到顶部 -->
    <el-backtop :bottom=" 80"></el-backtop>
    <!-- 路由 -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    document.addEventListener('contextmenu', this.disableRightClick);
  },
  beforeDestroy() {
    document.removeEventListener('contextmenu', this.disableRightClick);
  },
  methods: {
    disableRightClick(event) {
      event.preventDefault();
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow-x: hidden;
  max-width: 100%;

  img {
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    user-drag: none;
  }
}
@media screen and (max-width: 768px) {
  #app {
    padding: 10px;
  }
}

@media screen and (max-width: 480px) {
  #app {
    padding: 5px;
  }
}
</style>
